import { useQuery } from 'convex/react';
import { api } from '@aeon-karaoke/cloud-convex';
import type { Id } from '@aeon-karaoke/cloud-convex/_generated/dataModel';

export function useTrackAssets(trackId: Id<'tracks'> | undefined) {
  return useQuery(api.tracks.getAssetUrls, trackId ? { trackId } : 'skip');
}
